export enum ProgressDataType {
    Quest,
    Achievement,
    Criteria,
    AddonAchievement,
    SpentCyphers,
    AddonQuest,
    WodGarrison,
    SlCovenant,
    Always,
    HonorLevel,
    GarrisonTree,
    AccountQuest,
    Item,
    SpellKnown,
    QuestLine,
    Quests,
}
